import { render, staticRenderFns } from "./ProcessForm.vue?vue&type=template&id=4f0aacfc&scoped=true"
import script from "./ProcessForm.vue?vue&type=script&lang=js"
export * from "./ProcessForm.vue?vue&type=script&lang=js"
import style0 from "./ProcessForm.vue?vue&type=style&index=0&id=4f0aacfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0aacfc",
  null
  
)

export default component.exports